import Vue from "vue";
import VueRouter from "vue-router";
import moment from 'moment';

Vue.use(VueRouter);

function loadView(startDateTime, endDateTime){
  const now = moment();
  const start = moment(startDateTime, 'YYYY-MM-DD HH:mm');
  if(endDateTime){
    var end = moment(endDateTime, 'YYYY-MM-DD HH:mm');
  }
  if(now.isSameOrAfter(start)){
    if(endDateTime){
      if(now.isSameOrAfter(end)){
        return () => import('@/views/default/event/_oct2025.vue')
      }else{
        return () => import('@/views/default/event/_nov2025.vue')
      }
    }else{
      return () => import('@/views/default/event/_nov2025.vue')
    }
  }else{
    return () => import('@/views/default/event/_oct2025.vue')
  }
}

const routes = [
  // {
  //   path: "",
  //   component: () => import("@/views/default/index.vue"),
  //   children: [
  {
    path: "",
    component: () => import("@/views/default/index.vue"),
    children: [
      {
        path: "",
        // component: () => import("@/views/default/_hotGame.vue")
        component: () => import("@/views/default/_home.vue"),
      },
      {
        path: "/login",
        component: () => import("@/views/default/_login.vue"),
        meta: { beforeLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/login"
          }
        ]
      },
      {
        path: "/register",
        component: () => import("@/views/default/_signUp.vue"),
        meta: { beforeLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/register"
          }
        ]
      },
      {
        path: "/aboutUs",
        component: () => import("@/views/default/_aboutUs.vue"),
        children: [
          {
            path: "*",
            redirect: "/aboutUs"
          }
        ]
      },
      {
        path: "/faq",
        caseSensitive: true,
        component: () => import("@/views/default/_faq.vue"),
        children: [
          {
            path: "*",
            redirect: "/faq"
          }
        ]
      },
      {
        path: "/tnc",
        caseSensitive: true,
        component: () => import("@/views/default/_tnc.vue"),
        children: [
          {
            path: "*",
            redirect: "/tnc"
          }
        ]
      },
      {
        path: "/responsible-gaming",
        caseSensitive: true,
        component: () => import("@/views/default/_responsible.vue"),
        children: [
          {
            path: "*",
            redirect: "/responsible-gaming"
          }
        ]
      },
      {
        path: "/promotions",
        name: "promotions",
        component: () => import("@/views/default/_promotions.vue"),
        children: [
          {
            path: "*",
            redirect: "/promotions"
          }
        ]
      },
      {
        path: "/missions",
        component: () => import("@/views/default/_missions.vue"),
        children: [
          {
            path: "*",
            redirect: "/missions"
          }
        ]
      },
      {
        path: "/news",
        name: "news",
        component: () => import("@/views/default/_news.vue"),
        // children: [
        //   {
        //     path: ":slug",
        //     name: "news-details",
        //     component: () => import("@/views/default/_newsDetails.vue"),
        //   },
        // ],
      },
      {
        path: '/news/:slug',
        name: 'news-details',
        component: () => import("@/views/default/_newsDetails.vue"),
        props: true, // Allows route params to be passed as props
      },
      {
        path: "/live",
        component: () => import("@/views/default/_live.vue"),
        children: [
          {
            path: "*",
            redirect: "/live"
          }
        ]
      },
      {
        path: "/fish",
        component: () => import("@/views/default/_fish.vue"),
        children: [
          {
            path: "*",
            redirect: "/fish"
          }
        ]
      },
      {
        path: "/lottery",
        component: () => import("@/views/default/_lottery.vue"),
        children: [
          {
            path: "*",
            redirect: "/lottery"
          }
        ]
      },
      {
        path: "/poker",
        component: () => import("@/views/default/_poker.vue"),
        children: [
          {
            path: "*",
            redirect: "/poker"
          }
        ]
      },
      {
        path: "/minigame",
        component: () => import("@/views/default/_minigame.vue"),
        children: [
          {
            path: "*",
            redirect: "/minigame"
          }
        ]
      },
      {
        path: "/slot",
        name: "slot",
        component: () => import("@/views/default/_slot.vue"),
        children: [
          {
            path: "*",
            redirect: "/slot"
          }
        ]
      },
      // {
      //   path: "/hot",
      //   component: () => import("@/views/default/_hotGame.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/hot"
      //     }
      //   ]
      // },
      
      // {
      //   path: "/mega888",
      //   component: () => import("@/views/default/_mega888.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/mega888"
      //     }
      //   ]
      // },
      {
        path: "/freeplay",
        component: () => import("@/views/default/_freePlay.vue"),
        children: [
          {
            path: "*",
            redirect: "/freeplay"
          }
        ]
      },
      {
        path: "/reviews",
        name: "reviews",
        component: () => import("@/views/default/_reviews.vue"),
        children: [
          {
            path: "*",
            redirect: "/reviews"
          }
        ]
      },
      {
        path: "/partners",
        name: "partners",
        component: () => import("@/views/default/_partners.vue"),
        children: [
          {
            path: "*",
            redirect: "/partners"
          }
        ]
      },
      // {
      //   path: "/euro2024",
      //   component: () => import("@/views/default/event/_euro2024.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/euro2024"
      //     }
      //   ]
      // },
      {
        path: "/contactUs",
        component: () => import("@/views/default/_contactLobby.vue"),
        children: [
          {
            path: "*",
            redirect: "/contactUs"
          }
        ]
      },
      {
        path: "/referral",
        component: () => import("@/views/default/_referral.vue"),
        children: [
          {
            path: "*",
            redirect: "/referral"
          }
        ],
        // meta: { requiredLoggedIn: true}
      },
      {
        path: "/event",
        name: "event",
        // component: () => import("@/views/default/event/_eggsmash.vue"),
        component: loadView('2025-11-01 00:00'),
        children: [
          {
            path: "*",
            redirect: "/event"
          }
        ],
      },
      {
        path: "/inbox",
        component: () => import("@/views/default/_inboxMenu.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/inbox"
          }
        ]
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: () => import("@/components2/_forgotPassword.vue"),
        meta: { beforeLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/reset-password"
          }
        ]
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/default/_memberProfile.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/profile"
          }
        ]
      },
      {
        path: "/deposit",
        component: () => import("@/views/default/_deposit.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/deposit"
          }
        ]
      },
      {
        path: "/withdrawal",
        component: () => import("@/views/default/_withdrawal.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/withdrawal"
          }
        ]
      },
      {
        path: "/statement",
        name: "statement",
        component: () => import("@/views/default/_statement.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/statement"
          }
        ]
      },
      {
        path: "/online-casino-malaysia",
        component: () => import("@/views/default/news/_online-casino-malaysia.vue"),
        children: [
          {
            path: "*",
            redirect: "/online-casino-malaysia"
          }
        ],
        // meta: { requiredLoggedIn: true}
      },
      {
        path: "/mega888-test-id-percuma-terkini-2024",
        component: () => import("@/views/default/news/_mega888-test-id-percuma-terkini-2024.vue"),
        children: [
          {
            path: "*",
            redirect: "/mega888-test-id-percuma-terkini-2024"
          }
        ],
        // meta: { requiredLoggedIn: true}
      },
      {
        path: "/register-dapat-free-credit-e-wallet",
        component: () => import("@/views/default/news/_register-dapat-free-credit-e-wallet.vue"),
        children: [
          {
            path: "*",
            redirect: "/register-dapat-free-credit-e-wallet"
          }
        ],
        // meta: { requiredLoggedIn: true}
      },
      {
        path: "/epicwin-free-kredit-rm10",
        component: () => import("@/views/default/news/_epicwin-free-kredit-rm10.vue"),
        children: [
          {
            path: "*",
            redirect: "/epicwin-free-kredit-rm10"
          }
        ],
        // meta: { requiredLoggedIn: true}
      },
      {
        path: "/e-wallet-bonus-angpao-free-credit",
        component: () => import("@/views/default/news/_e-wallet-bonus-angpao-free-credit.vue"),
        children: [
          {
            path: "*",
            redirect: "/e-wallet-bonus-angpao-free-credit"
          }
        ],
        // meta: { requiredLoggedIn: true}
      },
      // {
      //   path: "/p2e",
      //   component: () => import("@/views/default/_p2e.vue")
      // },
      // {
      //   path:"epicChange",
      //   redirect: "/home"
      //   // component: () => import("@/views/default/_epicChange.vue"),
      //   // meta: { requiredLoggedIn: true}
      // },
      // {
      //   path: "*",
      //   redirect: "/"
      // },
    ],
    beforeEnter: (to, from, next) => {
      // Condition: Check if user is authenticated
      var filterList= [
        "https://epic11.co/",
        "http://epic11.co/",
        "https://www.epic11.co/",
        "http://www.epic11.co/",
        "https://stag.epicwin.app/"
      ]
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      var hasQueryStrings = Object.keys(to.query).length > 0;

      if (filterList.includes(site)) {
        if(hasQueryStrings){
          if(to.query.ref){
            if(to.query.ref == "REF0000357419"){
              next({ path: '/new-players', query: { ref: to.query.ref } });
            }else{
              next();
            }
          }else{
            next()
          }
        }else{
          next(); // Allow access
        }
       
      }else {
        next(); 
      }
    }
  },
  // {
  //   path: "/ibank",
  //   component: () => import("@/views/default/_ibank.vue")
  // },
  /* payment */
  {
    path: "/gspay",
    component: () => import("@/views/default/_gspay.vue")
  },
  {
    path: "/gspaysol",
    component: () => import("@/views/default/payment/_gspaysol.vue")
  },
  {
    path: "/gspayewallet",
    component: () => import("@/views/default/payment/_gspayewallet.vue")
  },
  {
    path: "/pebanktransfer",
    component: () => import("@/views/default/payment/_peBankTransfer.vue")
  },
  {
    path: "/pepin",
    component: () => import("@/views/default/payment/_pepin.vue")
  },
  {
    path: "/mytelco",
    component: () => import("@/views/default/payment/_mytelco.vue")
  },
  {
    path: "/winpay",
    component: () => import("@/views/default/_winpay.vue")
  },
  {
    path: "/sulifu",
    component: () => import("@/views/default/payment/_sulifu.vue")
  },
  {
    path: "/upay",
    component: () => import("@/views/default/payment/_upay.vue")
  },
  

  {
    path: "/launchMega",
    component: () => import("@/views/default/gameapi/_launchMega.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/launchOneapi",
    component: () => import("@/views/default/gameapi/_launchOneapi.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/new-players",
    component: () => import("@/views/default/_newPlayer.vue"),
    beforeEnter: (to, from, next) => {
      // Condition: Check if user is authenticated
      var filterList= [
        "https://epic11.co/",
        "http://epic11.co/",
        "https://www.epic11.co/",
        "http://www.epic11.co/",
        "https://epic11.net/",
        "http://epic11.net/",
        "https://www.epic11.net/",
        "http://www.epic11.net/",
        "https://epic188.asia/",
        "http://epic188.asia/",
        "https://www.epic188.asia/",
        "http://www.epic188.asia/",
        "https://stag.epicwin.app/",
        "https://member.epwuatmy788.com/",
        "http://localhost/"
      ]
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      console.log(site)
      next()
      if (filterList.includes(site)) {
        next(); // Allow access
      } else {
        next('/'); // Redirect to home
      }
    }
  },
  // {
  //   path: "/gspaycoupon",
  //   component: () => import("@/views/default/_gsPayCoupon.vue")
  // },
  // {
  //   path: "/ibankcoupon",
  //   component: () => import("@/views/default/_ibankCoupon.vue")
  // },
  // {
  //   path: "/pecoupon",
  //   component: () => import("@/views/default/_peBankCoupon.vue")
  // },
  // {
  //   path: "/winpaycoupon",
  //   component: () => import("@/views/default/_winpayCoupon.vue")
  // },
  // {
  //   path: "/wheel-of-fortune",
  //   component: () => import("@/views/default/_wheel.vue"),
  //   // meta: { requiredLoggedIn: true},
  //   children: [
  //     {
  //       path: "*",
  //       redirect: "/wheel-of-fortune"
  //     }
  //   ]
  // },
  // {
  //   path: "*",
  //   component: () => import("@/views/default/_errorPage.vue")
  // },
  {
    path: "*",
    redirect: "/"
  },
  //   ]
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
